import { Injectable } from "@angular/core";
import { XsHttpApiService } from "../../common/services/xs-http-api.service";
import { CoreCommonService } from "./core-common.service";
import { XsAppConfigService } from "../../common/services/xs-app-config.service";
import { PlusdCommonService } from "../../plusd/services/plusd-common.service";

@Injectable({
  providedIn: "root"
})

export class SsoService {
  constructor(
    public xsHttpApiService: XsHttpApiService,
    public coreCommonService: CoreCommonService,
    public xsAppConfigService: XsAppConfigService,
    public plusdCommonService: PlusdCommonService,
  ) { }

  autenticar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/sso/autenticar",
      parametro
    );
  }

  obtenerRuc(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/sso/obtener-ruc",
      parametro
    );
  }

  obtenerOpciones(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/sso/obtener-opciones",
      parametro
    );
  }

  cambiarClave(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/seguridad/CambiarClaveUsuario",
      parametro
    );
  }

  modificarEstadoClave(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/sso/modificar-estado-clave",
      parametro
    );
  }
}
